module.exports = __webpack_public_path__ + "static/media/logo.594ac3d8.svg";